import { Component, OnInit } from '@angular/core';
import { IconsRegistry } from '@seu-services';
import { completeIconSet } from '@seu-types';

@Component({
  selector: 'seu-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(private iconRegistry: IconsRegistry) {}

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.iconRegistry.registerIcons(completeIconSet);
  }
}
